(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kp-media-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Create and insert play buttons for all videos
  const addPlayButtons = function() {
    const videos = document.querySelectorAll('.kp-chip-showcase__media video');
    
    videos.forEach(video => {
      // If autoplay is not enabled, add a play button
      if (!video.hasAttribute('autoplay')) {
        // Create play button element
        const playButton = document.createElement('div');
        playButton.className = 'kp-video-play-button';
        playButton.innerHTML = `
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white">
            <polygon points="5,3 19,12 5,21"></polygon>
          </svg>
        `;
        
        // Add click event to play video
        playButton.addEventListener('click', function() {
          video.play();
          this.classList.add('hidden');
          
          // Show button again when video ends (if not looping)
          if (!video.hasAttribute('loop')) {
            video.addEventListener('ended', function() {
              playButton.classList.remove('hidden');
            });
          }
        });
        
        // Add pause event listener to show play button again
        video.addEventListener('pause', function() {
          if (!video.ended) {
            playButton.classList.remove('hidden');
          }
        });
        
        // Insert the play button as a sibling after the video
        video.parentNode.insertBefore(playButton, video.nextSibling);
      }
    });
  };
  
  // Get the slider container element
  const sliderContainer = document.querySelector('.kp-chip-showcase__swiper');

  // Get dynamic settings from data attributes with fallbacks
  const autoplayEnabled = sliderContainer.dataset.autoplay === 'true';
  const autoplaySpeed = parseInt(sliderContainer.dataset.autoplaySpeed) || 5000; // Default 5 seconds
  const slideSpeed = parseInt(sliderContainer.dataset.speed) || 800; // Default 800ms

  // Configure autoplay settings
  const autoplayConfig = autoplayEnabled ? {
    delay: autoplaySpeed,
    disableOnInteraction: false
  } : false;

  // Initialize Swiper with dynamic settings
  const swiper = new Swiper('.kp-chip-showcase__swiper', {
    loop: false,
    autoplay: autoplayConfig,
    speed: slideSpeed,
    slidesPerView: 'auto',
    centeredSlides: true,
    spaceBetween: 15,
    roundLengths: true,
    slideToClickedSlide: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '"></span>';
      }
    },
    on: {
      init: function() {
        // This function runs when the slider is first initialized
        handleActiveSlideVideo(this);
      }
    }
  });

  // Call function to add play buttons after swiper is initialized
  addPlayButtons();

  // Play/Pause button functionality
  const playPauseButton = document.querySelector('.kp-play-pause-button');
  const playIcon = playPauseButton.querySelector('.play-icon');
  const pauseIcon = playPauseButton.querySelector('.pause-icon');

  // Set initial state based on autoplay setting
  if (autoplayEnabled) {
    playIcon.classList.add('hidden');
    pauseIcon.classList.remove('hidden');
  } else {
    playIcon.classList.remove('hidden');
    pauseIcon.classList.add('hidden');
  }

  // Toggle play/pause
  playPauseButton.addEventListener('click', function() {
    if (playIcon.classList.contains('hidden')) {
      // Currently playing, so pause
      swiper.autoplay.stop();
      playIcon.classList.remove('hidden');
      pauseIcon.classList.add('hidden');
    } else {
      // Currently paused, so play
      swiper.autoplay.start();
      playIcon.classList.add('hidden');
      pauseIcon.classList.remove('hidden');
    }
  });

  // Function to handle video playback on the active slide
  function handleActiveSlideVideo(swiper) {
    // First pause all videos
    const allVideos = document.querySelectorAll('.kp-chip-showcase__media video');
    allVideos.forEach(video => {
      video.pause();
      
      // Make sure all videos are at the start
      video.currentTime = 0;
      
      // Show all play buttons
      const playButton = video.nextElementSibling;
      if (playButton && playButton.classList.contains('kp-video-play-button')) {
        playButton.classList.remove('hidden');
      }
    });

    // Then only play video on active slide if it has autoplay attribute
    const activeSlide = swiper.slides[swiper.activeIndex];
    if (activeSlide) {
      const isMobile = window.innerWidth <= 768;
      const activeVideo = isMobile
        ? activeSlide.querySelector('video.mobile-media')
        : activeSlide.querySelector('video.desktop-media');

      if (activeVideo && activeVideo.hasAttribute('autoplay')) {
        // Small delay to ensure proper initialization
        setTimeout(() => {
          activeVideo.play()
            .then(() => {
              // Hide the play button for this video
              const playButton = activeVideo.nextElementSibling;
              if (playButton && playButton.classList.contains('kp-video-play-button')) {
                playButton.classList.add('hidden');
              }
            })
            .catch(error => {
              console.log('Autoplay prevented:', error);
            });
        }, 100);
      }
    }
  }

  swiper.on('slideChange', function() {
    handleActiveSlideVideo(this);
  });

  // Handle window resize event to play correct video version
  window.addEventListener('resize', function() {
    handleActiveSlideVideo(swiper);
  });

  // Add global methods to control the slider (useful for external control)
  window.kpSlider = swiper;
  window.updateSliderOptions = function(options) {
    if (options.autoplay !== undefined) {
      if (options.autoplay) {
        swiper.autoplay.start();
        // Update play/pause button state
        playIcon.classList.add('hidden');
        pauseIcon.classList.remove('hidden');
      } else {
        swiper.autoplay.stop();
        // Update play/pause button state
        playIcon.classList.remove('hidden');
        pauseIcon.classList.add('hidden');
      }
    }

    if (options.autoplaySpeed !== undefined && options.autoplay) {
      swiper.params.autoplay.delay = options.autoplaySpeed;
      swiper.autoplay.stop();
      swiper.autoplay.start();
    }

    if (options.speed !== undefined) {
      swiper.params.speed = options.speed;
    }
  };
});

  } catch(e) { console.error(e); }
})();
})();
